module.exports = __webpack_public_path__ + "img/beat_the_coach.24bbb41d.png";